// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 305 ? "96b8373f" : chunkId) + "." + {"288":"9a0ee0a5591da92e","305":"e875be52ea6a0dbe","357":"5b577192299b7447"}[chunkId] + ".js";
};